import React from 'react';
import _ from 'lodash';
import { Spin, Drawer } from 'antd';
import debounce from 'debounce';

import * as globals from '../globals';
import Mapper from './Mapper';
import PracticeDetails from './PracticeDetails';
import MapControls from './MapControls';

// import '../style/Mapper.scss';

class MapperControl extends React.Component {
  state = {
    refs: {},
    practices: null,
    activePractice: null,
    bounds: null,
    google: false,
  };

  async componentDidMount() {
    this.cache = {};

    try {
      const snap = await globals.db
        .child('practices')
        .orderByChild('verified')
        .equalTo(true)
        .once('value');

      const filteredPracs = {};
      const practices = snap.val();
      for (const pracKey in practices) {
        const prac = practices[pracKey];
        if (prac.practiceStatus === 'closed') {
          console.log(`practiceStatus: ${prac.practiceStatus}`);
          continue;
        }
        filteredPracs[pracKey] = prac;
      }

      if (this.props.setNumPracs) {
        this.props.setNumPracs(Object.keys(filteredPracs || {}).length);
      }

      this.setState({ practices: filteredPracs });
      // for (let pracId in practices) {
      // }
    } catch (err) {
      console.log('error fetching practices');
      console.log(err);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    console.time('mcrender');
    return true;
  }

  setGoogle = goog => {
    console.log('setting google');
    // if (this.state.google) return;
    this.setState({ google: goog });
    if (this.state.refs['map']) {
      let mapRef = this.state.refs['map'];
      mapRef.controls = [];
      mapRef.mapTypes = new goog.maps.MapTypeRegistry();
      mapRef.overLayMapTypes = [];
    }
  };
  setActivePractice = i => {
    this.setState({ activePractice: i });
  };

  setRef = name => ref => {
    if (this.state.refs[name] !== undefined) return;
    this.setState({
      refs: {
        ...this.state.refs,
        [name]: ref,
      },
    });
  };

  setBounds = () => {
    if (!this.state.refs.map) return;
    if (!this.state.refs.map.getBounds()) return;
    if (!this.state.refs.map.getCenter()) return;
    this.setState({
      bounds: this.state.refs.map.getBounds(),
      center: this.state.refs.map.getCenter(),
    });
  };

  onPlacesChanged = debounce(() => {
    console.log('updating autocomplete...');
    if (!this.state.refs.search) {
      return;
    }

    const places = this.state.refs.search.getPlaces();
    if (!places || !places.length) {
      return;
    }

    console.time('onPlacesChanged');
    const bounds = new this.state.google.maps.LatLngBounds();

    places.forEach(place => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    let nextCenter = (places[0] || {}).position || this.state.center;

    this.setState({
      center: nextCenter,
      bounds: bounds,
    });
    this.state.refs.map.fitBounds(bounds);
    console.timeEnd('onPlacesChanged');
  }, 750);

  render() {
    let practicesInBounds = {};
    if (this.state.google && this.state.bounds && this.state.practices) {
      for (let pracId in this.state.practices) {
        let prac = this.state.practices[pracId];
        let loc;
        let key = `${prac.lat}_${prac.lng}`;
        if (this.cache[key]) {
          loc = this.cache[key];
        } else {
          let newLoc = new this.state.google.maps.LatLng({
            lat: prac.lat,
            lng: prac.lng,
          });
          this.cache[key] = newLoc;
          loc = newLoc;
        }

        if (this.state.bounds.contains(loc)) {
          practicesInBounds[pracId] = prac;
        }
      }
    }

    console.timeEnd('mcrender');

    let activePractice = null;
    if (this.state.practices) {
      if (this.state.activePractice) {
        activePractice = this.state.practices[this.state.activePractice];
      }
    }

    return (
      <div className="row wrap MapRow">
        <div className="col MapCol">
          <MapControls
            init={this.setRef('search')}
            onPlacesChanged={() => {
              console.log('search changed....');
              this.onPlacesChanged();
            }}
            bounds={this.state.bounds}
          />
          <div className="MapContainer">
            {this.state.practices == null ? (
              <div className="fullpage">
                <Spin />
              </div>
            ) : (
              <Mapper
                setGoogle={this.setGoogle}
                practices={this.state.practices}
                setActivePractice={this.setActivePractice}
                init={this.setRef('map')}
                setBounds={this.setBounds}
              />
            )}
          </div>
        </div>
        <Drawer
          visible={!!activePractice}
          width={Math.min(window.document.width, 400) || 400}
          title={_.get(activePractice, 'name')}
          onClose={() => {
            this.setState({ activePractice: null });
          }}
        >
          <PracticeDetails data={activePractice} />
        </Drawer>
        {false && this.props.hideDetails !== true && (
          <PracticeDetails
            data={
              this.state.activePractice !== null && this.state.practices
                ? this.state.practices[this.state.activePractice]
                : null
            }
          />
        )}
      </div>
    );
  }
}
export default MapperControl;
